import {
  Callout,
  CalloutHeading,
  CalloutText,
} from "@twilio-paste/core/callout";
import { Anchor } from "@twilio-paste/core/anchor";

import { UpsellCTABlock } from "@twiliointernal/e2-commons-shared-definitions";

interface UpsellCTAProps {
  block: UpsellCTABlock;
}

const UpsellCTA = ({ block }: UpsellCTAProps) => {
  const { title, description, link } = block.values;

  return (
    <Callout variant="neutral">
      <CalloutHeading as="h2">{title}</CalloutHeading>
      <CalloutText>{description}</CalloutText>
      <Anchor href={link.url} showExternal>
        {link.title}
      </Anchor>
    </Callout>
  );
};

export default UpsellCTA;
